import { render, staticRenderFns } from "./UnidadeField.vue?vue&type=template&id=43964612&"
import script from "./UnidadeField.vue?vue&type=script&lang=js&"
export * from "./UnidadeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports